import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { FieldLabel } from '~/modules/tasks/components/TaskDrawer/TaskResourceEstimates/TaskAllocationEditor';
import { useTaskEstimateRowContext } from '~/modules/tasks/components/TaskDrawer/TaskResourceEstimates/TaskEstimateRowContext';
import { FormattedHourCostItem } from './FormattedHourCostItem';

export const useStyles = makeStyles(theme => ({
  container: {},
  header: {
    color: theme.palette.text.secondary
  }
}));

export const EstimateItemMetric = ({
  formatMessageKey,
  cost,
  hours,
  classes: classesOverride,
  formattedHoursClasses,
  isReadOnlyView = true
}) => {
  const classes = useStyles({ classes: classesOverride });
  const { formatMessage } = useIntl();
  const { canViewCost } = useTaskEstimateRowContext();

  return (
    <div className={classes.container}>
      <FieldLabel
        variant="caption"
        className={classes.header}
        messageId={formatMessageKey}
      />
      <FormattedHourCostItem
        canViewCost={canViewCost}
        hours={hours}
        hoursSuffix={formatMessage({
          id: 'taskResourceEstimates.hoursSuffix'
        })}
        cost={cost}
        classes={formattedHoursClasses}
        isReadOnlyView={isReadOnlyView}
      />
    </div>
  );
};

EstimateItemMetric.propTypes = {
  formatMessageKey: PropTypes.string,
  cost: PropTypes.object,
  hours: PropTypes.number,
  classes: PropTypes.object,
  formattedHoursClasses: PropTypes.object,
  isReadOnlyView: PropTypes.bool
};

export default EstimateItemMetric;
